import Model from '@/Apis/Online_session'
import Controller from './Controller'
import sha1 from "js-sha1";

export default class OnlineSessionController extends Controller {
  constructor() {
    super(new Model())
  }
  async joinLecture(id, attend = true) {

    // window.open('/dashboard/#/meeting/' + id, 'popup', 'fullscreen=1,scrollbars=no,resizable=no');
    window.open('/dashboard/#/meeting/' + id, '_self', 'fullscreen=1,scrollbars=no,resizable=no');
  }

  async Join(params) {
    const res = await this.model.Join(params);
    return res;
  }
  async end(params) {
    const res = await this.model.end(params);
    return this.Poup(res);
  }
  //sendToBBB
  async sendToBBB(params) {
    const res = await this.model.sendToBBB(params);
    return res;
  }
  async reopen(id) {
    try {
      const res = await this.model.reopen(id);
      return this.Poup({ status: !!res?.ok, message: res?.message });
    } catch (error) {
      return this.Poup({ status: false, message: error?.response?.data?.message || 'Reopen failed' });
    }
  }
  async getRecordings(id) {

    //https://vc1.sunnah.live/bigbluebutton/api/getRecordings?meetingID=123456789&checksum=c279c1ddde0b5b329726cbc23ebefd6732f446b7
    const data = `meetingID=${id}`
    const checksum = sha1(
      "getRecordings" + data + "9jR3Y9VaB5fAQZcsKfJNafIL6ynZMahfLnkIDb6U14c"
    );
    //
    window.open(`https://vc3.sunnah.live/bigbluebutton/api/getRecordings?${data}&checksum=${checksum}`, 'popup', 'fullscreen=1,scrollbars=no,resizable=no');

  }


}
